module.exports = __webpack_public_path__ + "static/media/amazingbet.9783ab5f.png";